<template>
<div class="chapter">
<div class="inner_page">
<section class="SOM" epub:type="toc" role="doc-toc">
<h1 class="SOM_titre" epub:type="title">Contents</h1>
<div class="SOM_pre"><a href="#/pre2">Foreword by Simon J. Gathercole</a></div>
<div class="SOM_pre"><a href="#/pre3">Acknowledgments</a></div>
<div class="SOM_pre"><a href="#/pre4">Series Introduction: Studies in Christian Doctrine and Scripture (SCDS)</a></div>
<div class="SOM_pre"><a href="#/pre5">Abbreviations</a></div>
<div class="SOM_pre"><a href="#/pre6">Author’s Note on Sources</a></div>
<div class="SOM_pre"><a href="#/pre7">Introduction: The Son Who Became Son</a></div>
<div class="SOM_chap"><span href="#/chap1" title="Link target outside of Sample">1 A Classical Christological Toolkit</span></div>
<div class="SOM_chap"><span href="#/chap2" title="Link target outside of Sample">2 “Son” as Divine Designation</span></div>
<div class="SOM_chap"><span href="#/chap3" title="Link target outside of Sample">3 The Son’s Incarnate Mission</span></div>
<div class="SOM_chap"><span href="#/chap4" title="Link target outside of Sample">4 “Son” as an Office Christ Enters at His Enthronement</span></div>
<div class="SOM_chap"><span href="#/chap5" title="Link target outside of Sample">5 Hebrews’ Theandric Messiah</span></div>
<div class="SOM_appen"><span href="#/appen8" title="Link target outside of Sample">Conclusion: The One Word Needed</span></div>
<div class="SOM_appen"><span href="#/appen9" title="Link target outside of Sample">Bibliography</span></div>
<div class="SOM_appen"><span href="#/appen10" title="Link target outside of Sample">Name Index</span></div>
<div class="SOM_appen"><span href="#/appen11" title="Link target outside of Sample">Subject Index</span></div>
<div class="SOM_appen"><span href="#/appen12" title="Link target outside of Sample">Scripture Index</span></div>
<div class="SOM_appen"><span href="#/appen13" title="Link target outside of Sample">Ancient Writings Index</span></div>
<div class="SOM_appen"><span href="#/appen14" title="Link target outside of Sample">The Studies in Christian Doctrine and Scripture series</span></div>
<div class="SOM_appen"><span href="#/appen15" title="Link target outside of Sample">Notes</span></div>
<div class="SOM_appen"><span href="#/appen16" title="Link target outside of Sample">Praise for <span class="mev3">The Paradox of Sonship</span></span></div>
<div class="SOM_appen"><span href="#/appen17" title="Link target outside of Sample">About the Author</span></div>
<div class="SOM_pdf"><span href="#/fin_acheve" title="Link target outside of Sample">More Titles from InterVarsity Press</span></div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// sommaire.vue?5ac139f5